import React from "react";
import Actions from "../actions";

const TableBodyComponent = ({
  actions,
  getTableBodyProps,
  page,
  prepareRow,
  type,
}) => {
  return (
    <tbody {...getTableBodyProps()}>
      {page.map((row) => {
        if (row?.id?.includes(".")) {
          return null;
        }
        prepareRow(row);

        return (
          <React.Fragment key={`row-${row.id}`}>
            <tr {...row.getRowProps()}>
              {row.cells.map((cell, cellIndex) => (
                <td
                  key={`cell-${row.id}-${cellIndex}`}
                  {...cell.getCellProps()}
                >
                  {cell.render("Cell")}
                </td>
              ))}
              {actions ? <Actions row={row} type={type} /> : null}
            </tr>

            {row.isExpanded && row.subRows.length > 0
              ? row.subRows.map((subRow) => {
                  if (!subRow?.id?.includes(".")) {
                    return null;
                  }
                  prepareRow(subRow);

                  return (
                    <tr
                      key={`subRow-${row.id}-${subRow.id}`}
                      {...subRow.getRowProps()}
                    >
                      {subRow.cells.map((cell, cellIndex) => (
                        <td
                          key={`subCell-${row.id}-${subRow.id}-${cellIndex}`}
                          {...cell.getCellProps()}
                        >
                          {cell.render("Cell")}
                        </td>
                      ))}
                    </tr>
                  );
                })
              : null}
          </React.Fragment>
        );
      })}
    </tbody>
  );
};

export default TableBodyComponent;
